import { render, staticRenderFns } from "./InformationAdmin.vue?vue&type=template&id=6d0eb99d&scoped=true"
import script from "./InformationAdmin.vue?vue&type=script&lang=js"
export * from "./InformationAdmin.vue?vue&type=script&lang=js"
import style0 from "./InformationAdmin.vue?vue&type=style&index=0&id=6d0eb99d&prod&scoped=true&lang=scss"
import style1 from "./InformationAdmin.vue?vue&type=style&index=1&id=6d0eb99d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0eb99d",
  null
  
)

export default component.exports